import React from "react"
import Media from "react-media"
import { withRouter } from 'react-router-dom'

import LeftSide from 'components/molecules/access_left_side'
import { RightDiv } from '../styled'
import WizardForm from './wizard_form'
 
class IncompleteTypeClient extends React.Component {
    

    render() {
        return (
            <div className='d-flex'>
                <Media query={{ minWidth: 820 }}>
                    {matches =>
                        matches ? (
                        <LeftSide title='Completa tu registro'/>
                        ) : (
                        ''
                        )
                    }
                </Media>
                <RightDiv className='flex-fill d-flex flex-column'>
                    <WizardForm/>
                </RightDiv>
            </div>
        )
    }
}

export default withRouter(IncompleteTypeClient)